// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.question-card {
  padding: 1rem;
  background-color: var(--question-card-bg-color);
  border-radius: 0.4rem;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  border: 2px solid var(--primary-color);
  transition: border-color 0.5s ease;
}
.question-card.hoverable {
  cursor: pointer;
}
.question-card.submitted {
  opacity: 0.6;
  border: 2px solid black;
  background-color: var(--question-card-hover-bg-color);
}
.question-card.noOnClick {
  cursor: default !important;
}
.question-card:hover {
  border-color: black;
}
.question-card__header {
  display: flex;
  gap: 1rem;
  position: relative;
}
.question-card__user {
  margin: 0;
  font-size: 0.9rem;
}
@media (max-width: 1366px) {
  .question-card__user {
    font-size: 0.5rem;
  }
}
.question-card__label {
  font-size: 0.65rem;
  margin: 0;
}
@media (max-width: 1366px) {
  .question-card__label {
    font-size: 0.55rem;
  }
}
.question-card__delete-button {
  position: absolute;
  right: 0;
}
.question-card__date {
  font-size: 0.7rem;
}
.question-card__avatar {
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  border-radius: 100%;
  color: var(--question-card-avatar-color);
  font-size: 1.2rem;
  font-weight: 500;
  background-color: var(--question-card-avatar-bg-color);
}
.question-card__question {
  margin-top: 1rem;
  margin-bottom: 0.4rem;
  color: var(--question-card-text-color);
}
@media (max-width: 1366px) {
  .question-card__question {
    font-size: 0.75rem;
  }
}
.question-card__textarea {
  margin: 1rem 0;
  border-radius: 0.4rem;
}
.question-card__textarea:hover, .question-card__textarea:focus {
  border-color: var(--question-editable-card-focus-textarea-border-color);
}
.question-card__actions {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 1rem;
}
@media (max-width: 1366px) {
  .question-card__actions {
    flex-wrap: wrap-reverse;
    gap: 0.5rem;
  }
}
@media (max-width: 1024px) {
  .question-card__actions {
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ui/QuestionCard/QuestionCard.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,+CAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,sCAAA;EACA,kCAAA;AACJ;AACI;EACI,eAAA;AACR;AAEI;EACI,YAAA;EACA,uBAAA;EACA,qDAAA;AAAR;AAGI;EACI,0BAAA;AADR;AAII;EACI,mBAAA;AAFR;AAKI;EACI,aAAA;EACA,SAAA;EACA,kBAAA;AAHR;AAMI;EACI,SAAA;EACA,iBAAA;AAJR;AAMQ;EAJJ;IAKQ,iBAAA;EAHV;AACF;AAMI;EACI,kBAAA;EACA,SAAA;AAJR;AAMQ;EAJJ;IAKQ,kBAAA;EAHV;AACF;AAMI;EACI,kBAAA;EACA,QAAA;AAJR;AAOI;EACI,iBAAA;AALR;AAQI;EACI,aAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;EACA,sDAAA;AANR;AASI;EACI,gBAAA;EACA,qBAAA;EACA,sCAAA;AAPR;AASQ;EALJ;IAMQ,kBAAA;EANV;AACF;AASI;EACI,cAAA;EACA,qBAAA;AAPR;AASQ;EAEI,uEAAA;AARZ;AAYI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,SAAA;AAVR;AAYQ;EAPJ;IAQQ,uBAAA;IACA,WAAA;EATV;AACF;AAWQ;EAZJ;IAaQ,uBAAA;EARV;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
